<template>
  <div class="question-identifier" aria-hidden="true">
    {{ questionIdentifier }}
  </div>
</template>
<script>
/**
 * An identifier to make it easy to find questions based on screen shots from end users.
 *
 * An example of a question identifier could be 101-201-210002 where 101 is topic-id,
 * 201 is lesson-id and 210002 is the question-id.
 *
 * The required data parameter should at least contain a Question object with an ID.
 * If Topic and Lesson objects are includes their IDs will be included in the question identifier.
 */

export default {
  name: 'question-identifier',
  props: {
    data: {
      type: Object,
      required: true,
      validator(data) {
        return !!(data.Question && data.Question.id)
      },
    },
  },
  computed: {
    topicId() {
      return this.data.Topic ? this.data.Topic.id : null
    },
    lessonId() {
      return this.data.Lesson ? this.data.Lesson.id : null
    },
    questionId() {
      return this.data.Question.id
    },
    questionIdentifier() {
      return (
        // Put all of the given IDs in an array
        [this.topicId, this.lessonId, this.questionId]
          // Remove any invalid IDs
          .filter(val => val !== null)
          // Join with dashes between the IDs
          .join('-')
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.question-identifier {
  position: absolute;
  left: 1em;
  bottom: 1em;
  font-size: 0.7em;

  @media (max-width: 30rem) {
    bottom: 3em;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
